export default __webpack_public_path__ + "static/media/snow-default-dark.53ca2c34.png";